import DataTable from 'react-data-table-component';
import { fetchUnderStock } from '../../resources/DashboardResource';
import React, { useEffect, useState } from "react";

export default function UnderStockList() {

    const [dataUnderStock, setDataUnderStock] = useState([]);

    const fetchDataUnderStock = () => {
        fetchUnderStock()
            .then((res) => {
                setDataUnderStock(res.data);
            })
            .catch((err) => {
                setDataUnderStock([]);
            });
    };

    useEffect(() => {
        fetchDataUnderStock();
    }, []);

    const columns = [
        {
            name: 'No',
            cell: (row, index) => index + 1,
            width: '60px'
        },
        {
            name: 'Part Number',
            selector: row => row.part_number,
            sortable: true,
            width: '140px'
        },
        {
            name: 'Part Name',
            selector: row => row.part_name,
            sortable: true,
            width: '140px'
        },
        {
            name: 'Standard Stock',
            selector: row => row.standart_stock,
            sortable: true,
        },
        {
            name: 'Total Stock',
            selector: row => row.total_stock,
            sortable: true,
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={dataUnderStock}
        />
    );
}